/**
 * Module 83 (WP-83.7) — the REVEAL button's low-moves highlight and tip, the
 * rules Module 81 (D3) wrote for the Hint, carried over to its replacement.
 *
 * Pure: the plugin gathers the moment, this says whether the button lights.
 */
/** `seenTutorials` entry: the "Stuck?" tip has been shown once, ever. */
export const REVEAL_TIP_SEEN = 'revealTip';
/** The economy reason id of a Reveal purchase — migration 0017's allowlist row. */
export const REVEAL_REASON_ID = 'blockjam_reveal';
export function shouldHighlightReveal(cfg, m) {
    if (m.busy || m.movesLeft === null || m.movesLeft <= 0)
        return false;
    if (m.revealed)
        return false;
    if (m.attemptNumber < cfg.fromAttempt)
        return false;
    if (m.highlightedThisAttempt)
        return false;
    if (cfg.maxPerPuzzle > 0 && m.highlightsThisPuzzle >= cfg.maxPerPuzzle)
        return false;
    if (m.movesLeft > cfg.highlightAtOrBelow)
        return false;
    if (cfg.requireShortfall && m.movesLeft >= m.blocksLeft)
        return false;
    return true;
}
export function shouldShowRevealTip(cfg, tipSeenEver, highlightsBefore) {
    if (!tipSeenEver)
        return true;
    return cfg.tipEveryPuzzle && highlightsBefore === 0;
}
export function revealReason(input) {
    if (input.exited)
        return 'out';
    for (const id of input.poweredAfter)
        if (!input.poweredBefore.has(id))
            return 'gate';
    return 'room';
}
